import styled from 'styled-components';
import colors from '../../styles/colors';

export const Form = styled.form`
  display:flex;
  position:relative;
  justify-content:'center';
  padding: 0px 30px;
  width:700px;
  height: auto;
  flex-direction:column;
  padding:30px 10px;

  @media screen and (max-width:991px){
    width: 100% !important;
  }
`;

export const Label = styled.label`
  color: ${colors.grey3};
  display: flex;
  flex:1;
  font-size: 13px;
  margin-left: 10px;
  
  @media screen and (max-width:991px){
    margin-right: 0px;
  }
`;
export const InputSection = styled.div`
  margin: 10px 0px ;
  width: ${(props) => props.width || '100%'};
  padding:10px 0;
  display: flex;
  /* ${(props) => props.justify && 'padding: 0 70px'}; */
  flex-direction: row;
  height: ${(props) => (props.height ? props.height : 'auto')};
  align-items: flex-start;
  ${(props) => (props.noBorder ? null : ` border: 1px solid ${colors.grey5}`)};
  border-radius: 7px;
  ${(props) => props.justify && `justify-content: ${props.justify}`};
  min-height: 40px;
  position: relative;

  @media screen and (max-width:991px){
    width: 100% !important;
    justify-content: space-evenly;

  }
`;
export const ButtonContainer = styled(InputSection)`
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-flow:row wrap;
`;

export const MessageDetails = styled.div`
  display:flex;
  font-size: 1.2rem;
  color: ${colors.grey3};
  padding: 0 5px;
  margin: ${(props) => (props.top ? '0px 0px 10px 0px' : '30px 0px 10px 0px')};

`;

export const ImageDataContainer = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  justify-content: center;
  height:auto;
`;

export const ImageInputContainer = styled.div`
  width: 100%;
  opacity: ${(props) => props.opacity || '0'};
  z-index: 10;
  height:auto;
`;

export const ImageContainer = styled.div`
  top: 0px;
  left: 0px;
  position: absolute;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
`;

export const ImagePreview = styled.img`
  max-width: 100%;
  height: 180px;
  border-radius: 7px;
  opacity: ${(props) => props.opacity};
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin:${(props) => props.margin || '0'};
  align-items: center;
  justify-content: space-evenly;
   @media (max-width:991px){
    justify-content: space-evenly;
   }
   @media (max-width:480px){
    margin:${(props) => props.marginXs || '0'};
   }
`;

export const MessageDiv = styled.div`
  display: flex;
  width:100%;
  border-radius: 7px;
  border: 1px solid ${colors.grey5};
  overflow: auto;
  word-break: break-word;

  `;
